<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("message.servicesFeatures") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.flexiblePricing">{{ $t("plans.flexiblePricing") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.unlimitedCBScenario">{{
                        $t("plans.unlimitedCBScenario")
                    }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.freeFirstScenario">{{ $t("plans.freeFirstScenario") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.rightToCancel">{{ $t("plans.rightToCancel") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.unlimitedLearn">{{ $t("plans.unlimitedLearn") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.allPlatformIntegration">{{
                        $t("plans.allPlatformIntegration")
                    }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.aiSupport">{{ $t("plans.aiSupport") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.creativeAI">{{ $t("plans.creativeAI") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.unlimitedSession">{{ $t("plans.unlimitedSession") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.assistantFromWebsite">{{
                        $t("plans.assistantFromWebsite")
                    }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.assistantFromDoc">{{ $t("plans.assistantFromDoc") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.mobileApp">{{ $t("plans.mobileApp") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.whatsapp">{{ $t("message.whatsapp") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.email">{{ $t("message.email") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.web">{{ $t("message.web") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.instagram">{{ $t("message.instagram") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.messenger">{{ $t("message.messenger") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.apiUsage">{{ $t("message.apiUsage") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.excelDownload">{{ $t("message.excelDownload") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.customerGroup">{{ $t("message.customerGroups") }}</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            flexiblePricing: false,
            unlimitedCBScenario: false,
            freeFirstScenario: false,
            rightToCancel: false,
            unlimitedLearn: false,
            allPlatformIntegration: false,
            aiSupport: false,
            creativeAI: false,
            unlimitedSession: false,
            assistantFromWebsite: false,
            assistantFromDoc: false,
            mobileApp: false,
            whatsapp: false,
            email: false,
            web: false,
            instagram: false,
            messenger: false,
            manageInbox: false,
            commentManagement: false,
            privateReplyMessage: false,
            mentionTicket: false,
            manageWithChatbot: false,
            apiUsage: false,
            excelDownload: false,
            customerGroup: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.SERVICES);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.SERVICES, ...this.featureForm };
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.SERVICES);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
